module.exports = __webpack_public_path__ + "static/media/mail-icon.81dce4f4.png";